import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Pagination } from '../../../../components/Pagination';
import './TablaAccesosProducto.css';
import { State } from "../../../../reducers";
import { actionsGPAgregarProducto } from "../../../../actions/action-creators";
import { actionsGPEditarProducto } from "../../../../actions/action-creators";
import { gp_ap_SetSucursalesSeleccionadas} from "../../../../actions/gestion-producto/agregar-producto/agregarProducto.actions";
import { gp_ep_SetSucursales,
    gp_ep_SetSucursalesAsignadas,
    gp_ep_SetProductoSeleccionado,
    gp_ep_EditarProducto }
    from "../../../../actions/gestion-producto/editar-producto/editarProducto.actions";
import { convertStringToNit } from "../../../../utils/strings.utils";

import { validacionesOnBlurProducto } from "../../../../actions/gestion-producto/agregar-producto/agregarProducto.actions";

const TablaAccesosEditarProducto = () => {
    const sucursales = useSelector(
            (state: State) => state.gestionProducto.editarProducto.catalogos.sucursales
    );
    const seleccionado = useSelector(
        (state: State) => state.gestionProducto.editarProducto.productoSeleccionado
    );

    const [currentItems, setCurrentItems] = useState<Array<any>>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);

    const dispatch = useDispatch();
    const acciones = bindActionCreators(actionsGPEditarProducto, dispatch);

    const sucursalesActivas = useMemo(
            () => sucursales.filter(sucu => sucu.activo === "true" && sucu.eliminado !== "1"),
            [sucursales]
    );
    const asignadas = useMemo(
            () => sucursales.filter(s => s.Relacionada === true || s.Relacionada === "true").map(s => String(s.idsucursal)),
            [sucursales]
    );

    useEffect(() => {
}, [sucursales]);


    useEffect(() => {
    if (sucursalesActivas.length > 0) {
        setCurrentItems(sucursalesActivas.slice(0, 15));
    }
}, [sucursalesActivas]);


  useEffect(() => {
  if (seleccionado?.idproducto) {
    acciones.gp_ep_getSucursales(seleccionado.idproducto);
  }
}, [seleccionado]);



    useEffect(() => {
    if (sucursalesActivas.length > 0) {
        setSelectedRows(asignadas);
        setSelectAll(asignadas.length === sucursalesActivas.length);
    }
}, [seleccionado, sucursalesActivas, asignadas]);


         useEffect(() => {
                dispatch(gp_ep_SetSucursalesAsignadas(selectedRows));
            }, [selectedRows, dispatch]);


            const handleCheckboxChange = (event: any, rowId: string) => {
        if (event.target.checked) {
            setSelectedRows([...selectedRows, rowId]);
        } else {
            setSelectedRows(selectedRows.filter((id) => id !== rowId));
        }
    };
    const handleSelectAll = () => {
  const newSelectAll = !selectAll;
  setSelectAll(newSelectAll);
  if (newSelectAll) {
    setSelectedRows(sucursalesActivas.map(s => String(s.idsucursal)));
  } else {
    setSelectedRows([]);
  }
};

    

    return (
        <div className='tab-plane mt-16'>
            <table className='ta-cu-table-main-responsive ta-cu-responsive-table-main td-left table-pointer'>
                <thead>
                    <tr>
                        <td>
                            <label className="w-checkbox" style={{ marginLeft: "3%" }}>
                                <input
                                    autoComplete="off"
                                    type="checkbox"
                                    checked={selectedRows.length === sucursalesActivas.length}
                                    onChange={handleSelectAll}
                                />
                                <div className="checkbox__checkmark"></div>
                                <div className="checkbox__body" style={{ fontWeight: "400" }}>
                                    No. Sucursal
                                </div>
                            </label>
                        </td>
                        <td>Nombre</td>
                        <td>Dirección</td>
                        <td>NIT</td>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.length === 0 && (
                        <tr>
                            <td colSpan={4} style={{ textAlign: "center", padding: "20px 0px" }}>
                                No hay sucursales activas para asignar al producto
                            </td>
                        </tr>
                    )}
                    {currentItems.map((element, index) => (
                        <tr key={index}>
                            <td data-label="No. Sucursal" onClick={(e) => e.stopPropagation()}>
                                <label className="w-checkbox" style={{ marginLeft: "3%" }}>
                                    <input
                                        autoComplete="off"
                                        type="checkbox"
                                        checked={selectedRows.includes(String(element?.idsucursal))}
                                        onChange={(e) => handleCheckboxChange(e, String(element?.idsucursal))}
                                    />
                                    <div className="checkbox__checkmark"></div>
                                    <div className="checkbox__body fw-400">{index + 1}</div>
                                </label>
                            </td>
                            <td data-label="Nombre">{element.nombre}</td>
                            <td data-label="Dirección">{element.direccion}</td>
                            <td data-label="NIT">{convertStringToNit(String(element.nit))}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Pagination
                data={currentItems}
                state={(items: any[]) => setCurrentItems(items)}
                items={15}
            />
        </div>
    );
};

export default TablaAccesosEditarProducto;